import React from 'react';

const stats = [
  { value: '25+', label: 'Research shows up to 25+ years shelf life' },
  { value: '✓', label: 'Superior Nutrient Retention' },
  { value: '1,000+', label: 'Meal Options' },
  { value: '2 Year', label: 'Limited Warranty' }
];

export const StatsSection = () => {
  return (
    <section className="py-20 bg-[#003456]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8 text-center text-white">
          {stats.map((stat, i) => (
            <div key={i}>
              <p className="text-5xl font-bold mb-2" style={{ fontFamily: 'JetBrains Mono' }}>{stat.value}</p>
              <p className="text-white/70">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
